export default "__VITE_ASSET__DF_YJA59__"